import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// date au format YYYY-MM-DD (input type="date") — optionnelle, defaut serveur =
// aujourd'hui (heure Port-au-Prince) si omise.
// tirage = code loterie (optionnel, '0'/vide = toutes), no = Ticket.no (N° de
// fiche propre a la loterie, optionnel) — ciblage plus fin en plus de sq.
export const searchNullifyTickets = ({ bank, sq, searchBy, date, tirage, no, serial }) =>
  apiRequest(`/tickets/nullify/search/${toQuery({ bank, sq, search_by: searchBy, date, tirage, no, serial })}`);

export const nullifyTicket = (ticketId) =>
  apiRequest(`/tickets/nullify/${ticketId}/`, { method: 'POST' });
